import { Button, CardContent, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MyTable from "../../../components/MyTable";
import { searchCompanyEmployees } from "../../../store/slices/userRequests";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import styled from "@emotion/styled";
import { setApprovalEmployees, setApprovalResponsables } from "../../../api/s10OrganizationApi";

interface ChipData {
    key: string;
    label: string;
}

interface EmployeesModalProps {
    ruc: string;
    approvalGroupId: string;
    handleCloseModal: ({success, msg}: {success?: boolean, msg?: string}) => void;
    action: "addEmployees" | "addResponsables"
}


const ListItem = styled('li')(({ theme }) => ({
    margin: (theme as any).spacing(0.5),
}));

const EmployeesModal = ({ruc, approvalGroupId, handleCloseModal, action,}: EmployeesModalProps) => {

    const dispatch = useDispatch<AppDispatch>();
    const {connectionId} = useSelector((state: RootState) => state.auth);
    const {employees, loading, totalItems} = useSelector((state: RootState) => state.userRequests).companyEmployees;
    const userAdded = useRef<ChipData[]>([]);
    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("")
    const [selectedUsers, setSelectedUsers] = useState<readonly ChipData[]>([]);


    useEffect(() => {
       const copyUsers = [...selectedUsers]
        userAdded.current = copyUsers;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedUsers])


    const EmployeesHeader = [
    {
        label: "Nombre",
        rowKeyName: "Descripcion",
    },{
        label: "Documento",
        rowKeyName: "DNI",
    },{
        label: "Email",
        rowKeyName: "EMail",
    }]

    const handleAdd = (user: ChipData) => {
        const users = [...userAdded.current];
        if (!users.find(u => u.key === user.key)) {
            const users = userAdded.current;
            setSelectedUsers([...users, user]);
        } else {
            setSelectedUsers((selectedUsers) => selectedUsers.filter((u) => u.key !== user.key));
        }
    };

    const handleDelete = (userToDelete: ChipData) => () => {
        setSelectedUsers((selectedUsers) => selectedUsers.filter((user) => user.key !== userToDelete.key));
    };
    
    useEffect(() => {
        if (loading || !connectionId || !ruc) {
            return;
        }
        dispatch(searchCompanyEmployees(ruc, pageSize, page, searchValue))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId, ruc, pageSize, page, searchValue]);


    const handleSaveAction = async () => {
        if (action === "addResponsables") {
            const {data} = await setApprovalResponsables(approvalGroupId, selectedUsers.map(s => s.key))
            const msg = data?.Type === 0
                ? 'Responsables agregados con éxito.'
                : 'Error agregando los responsables';
            handleCloseModal({
                success: data?.Type === 0,
                msg,
            }); 
        } else if (action === "addEmployees") {
            const {data} = await setApprovalEmployees(approvalGroupId, selectedUsers.map(s => s.key))
            console.log(data)
            const msg = data?.Type === 0
                ? 'Colaboradores agregados con éxito.'
                : 'Error agregando los colaboradores';
            handleCloseModal({
                success: data?.Type === 0,
                msg,
            }); 
            
        }
    }
    console.log(employees)

    return (

        <Dialog
            fullWidth={true}
            open={true}
            maxWidth={'lg'}
            style={{width: "-webkit-fill-available", maxWidth: "100%"}}
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Agregar {action === "addResponsables" ? "responsables" : "colaboradores"}
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center", minHeight: "600px"}}>
                <Grid
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        listStyle: 'none',
                        p: 0.5,
                        m: 0,
                    }}
                    component="ul"
                >
                    {selectedUsers.map((data, i) => {
                        let icon;

                        return (
                        <ListItem key={i}>
                            <Chip
                                icon={icon}
                                label={data.label}
                                onDelete={handleDelete(data)}
                            />
                        </ListItem>
                        );
                    })}
                </Grid>
                <MyTable
                    tableHeadRows={EmployeesHeader}
                    tableRows={employees}
                    onChangeItemsPerPage={setPageSize}
                    onChangePageNumber={setPage}
                    onChangeSearchInputString={setSearchValue}
                    searchInputString={searchValue}
                    totalItems={totalItems}
                    totalPages={totalItems / pageSize}
                    loading={false}
                    cardComponent={{
                        imageData: {
                            descriptionRowName: "Descripcion",
                        },
                        cardContent:  (row) => {
                            return (
                                <CardContent style={{padding: "0 1rem 1rem 50px", textAlign: "start"}}>
                                    <Typography variant="body2" color="text.primary">
                                        {row.DNI} 
                                    </Typography>
                                    <Typography variant="body2" color="text.primary">
                                        {row.EMail} 
                                    </Typography>
                                </CardContent>
                            )
                        },
                        onClick: (row) => {
                            console.log(selectedUsers)
                            
                            return handleAdd({key: row.CodIdentificador, label: row.Descripcion})
                        },
                        className: (row) => {
                            return selectedUsers.find(e => e.key === row.CodIdentificador)
                                ? "selectable-card-selected"
                                : "selectable-card"
                        }
                    }}
                    tableOptionsBar={{
                        useDrawer: false,
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => handleCloseModal({})}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={handleSaveAction}
                            disabled={selectedUsers.length === 0}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default EmployeesModal;